/* global openPopup, closePopup, $popup, $overlay, submitNewsletter */
// ===========================================================================
// POPUP ISCRIZIONE NEWSLETTER + POPUP CHIUSURA PER FERIE
// ===========================================================================
$(document).ready(function () {

  let pageNum = Cookies.get('pageNum');
  if (pageNum === undefined) {
    pageNum = 1;
  } else {
    pageNum = parseInt(pageNum, 10) + 1;
  }
  // console.log(pageNum);
  Cookies.set('pageNum', pageNum, {
    expires: 1
  });

  if (pageNum === 2) {
    const dismissedPopup = Cookies.get('newsletterClosed');
    if (dismissedPopup !== 'dismissed') {
      openPopup($('#popup-newsletter'), $overlay);
    }
  }
});

$('.close-newsletter-popup').click(function () {
  Cookies.set('newsletterClosed', 'dismissed', {
    expires: 45
  });
  closePopup($popup, $overlay);
});

$('body').on('click', '.show-newsletter-popup', function () {
  openPopup($('#popup-newsletter'), $overlay);
});

// $('#popup-chiusura').on('click', '.close-popup', function() {
//   Cookies.set('vacanze', 'vacanze', { expires: 1 });
// });
//
// var vacanzaCookie = Cookies.get('vacanze');
// if (vacanzaCookie != 'vacanze') {
//   openPopup($('#popup-chiusura'),overlay);
// }


/*
==============================================================================
GESTIONE DELLA POPUP ISCRIZIONE ALLA NEWSLETTER
------------------------------------------------------------------------------
==============================================================================
*/
/*
$('#popup-newsletter').on('click', '#submit-newsletter', function () {

  // Cacho il campo per visualizzare gli eventuali errori
  const $errore = $('#popup-newsletter .error-message');

  // Prendo gli elementi del pulsante e della form
  const $form = $('#popup-newsletter form');
  const $pulsante = $('#submit-newsletter');

  // Prendo le informazioni inserite dall'utente
  const nlemail = $('input[name="Iscritti_email"]').val();
  let nlnome = $('input[name="Iscritti_nome"]').val();
  let nlcognome = $('input[name="Iscritti_cognome"]').val();

  // Controllo se i valori esistono
  if (nlemail === undefined || nlemail === null || !nlemail.length) {
    $errore.text('ERRORE - IL CAMPO EMAIL E\' OBBLIGATORIO');
    return;
  }
  if (nlnome === undefined || nlnome === null || !nlnome.length) {
    $errore.text('ERRORE - IL CAMPO NOME E\' OBBLIGATORIO');
    return;
  }
  if (nlcognome === undefined || nlcognome === null || !nlcognome.length) {
    $errore.text('ERRORE - IL CAMPO COGNOME E\' OBBLIGATORIO');
    return;
  }

  const newsletterCheckbox = document.getElementById('Iscritti_newsletter');
  if (!newsletterCheckbox.checked) {
    $errore.text('ERRORE - Devi accettare la nostra politica privacy');
    newsletterCheckbox.style.borderColor = 'red';
    return;
  }

  // controllo se l'indirizzo email è formalmente valido
  const re = /.+@.+\..+/i;
  if (re.test(nlemail) === false) {
    $errore.text('ERRORE - INDIRIZZO EMAIL NON VALIDO');
    return;
  }

  // Rimuovo qualsiasi carattere non conforme (speciale) dal nome e dal cognome
  nlnome = nlnome.replace(/[-'`~!@#$%^&*()_|+=?;:'",.<>\{\}\[\]\\\/]/gi, '');
  nlcognome = nlcognome.replace(/[-'`~!@#$%^&*()_|+=?;:'",.<>\{\}\[\]\\\/]/gi, '');

  // Faccio l'encode dei caratteri speciali
  nlnome = encodeURIComponent(nlnome);
  nlcognome = encodeURIComponent(nlcognome);

  // Setto il cookie per non far rivedere la popup newsletter
  Cookies.set('newsletterClosed', 'dismissed', {
    expires: 45
  });

  // Avvio l'iscrizione alla newsletter
  submitNewsletter($form, $pulsante, nlemail, nlnome, nlcognome, true);
});
*/


/*
GESTIONE DELLA POPUP ISCRIZIONE ALLA NEWSLETTER
*/

document.getElementById('submit-newsletter').addEventListener('click', function () {

  // flag di controllo per la submit della form senza errori
  let flag = true;

  const errore = document.querySelector('.error-message');

  // codice legacy con jquery per compatibilità routine di iscrizione alla nl
  const $form = $('#popup-newsletter form');
  const $pulsante = $('#submit-newsletter');

  const nlemail = document.querySelector('input[name="Iscritti_email"]').value;
  const nlnome = document.querySelector('input[name="Iscritti_nome"]').value;
  const nlcognome = document.querySelector('input[name="Iscritti_cognome"]').value;

  const nlCheckbox = document.getElementById('Iscritti_newsletter');

  if (!nlemail.length && flag) {
    errore.innerText = 'ERRORE - Devi inserire un email';
    flag = false;
  }
  if (!nlnome.length && flag) {
    errore.innerText = 'ERRORE - Devi inserire il nome';
    flag = false;
  }
  if (!nlcognome.length && flag) {
    errore.innerText = 'ERRORE - Devi inserire il cognome';
    flag = false;
  }
  if (!nlCheckbox.checked && flag) {
    errore.innerText = 'ERRORE - Devi accettare la nostra politica privacy';
    nlCheckbox.style.borderColor = 'red';
    flag = false;
  }

  if (flag) {
    Cookies.set('newsletterClosed', 'dismissed', {
      expires: 45
    });
    submitNewsletter($form, $pulsante, nlemail, nlnome, nlcognome, true);
  }

});
